module.exports = __webpack_public_path__ + "img/gin.dd5043f7.jpg";